export default {
  init() {

  },
  finalize() {
    const $chipFilterWrap = $('.chip-filter-wrap');
    const $mobileWrap = $('.chip-filter-mobile-dropdown-wrap');

    if ($chipFilterWrap.length > 0) {
      /** DESKTOP **/
      // Toggle the filter dropdown
      $('#filter-dropdown-toggle').on('click', function () {
        $('#filter-dropdown').toggleClass('open');
      });

      $(window).on('click', function(e) {
        if ($(e.target).attr('id') != 'filter-dropdown' && $(e.target).parents('.filter-dropdown').length == 0 && $(e.target).attr('id') != 'filter-dropdown-toggle') {
          // not clicking on the filter OR toggle button - close the filter
          $('#filter-dropdown').removeClass('open');
        }
      });

      // Select a filter item
      $('#filter-dropdown .filter-dropdown-term .term-btn').on('click', function() {
        $(this).toggleClass('checked');
      });

      // Update filters
      $('#filter-dropdown .filter-update').on('click', function() {
        updateFilters();
      });

      // Deselect a filter item
      $('.term-btn-remove').on('click', function() {
        const termId = $(this).data('term-id');

        $(`#filter-dropdown .filter-dropdown-term .term-btn[data-term-id="${termId}"]`).removeClass('checked');

        updateFilters();
      });

      /** MOBILE **/
      $('#filter-dropdown-mobile-toggle').on('click', function() {
        $mobileWrap.addClass('open');
        $('body').addClass('overflow-hidden');
      });

      $mobileWrap.find('.top-close-btn').on('click', function() {
        $mobileWrap.removeClass('open');
        $('body').removeClass('overflow-hidden');
      });

      $mobileWrap.find('.mobile-term-btn').on('click', function() {
        $(this).toggleClass('checked');
      });

      $mobileWrap.find('.mobile-update-btn').on('click', function() {
        updateFilters('mobile');
      });

      $mobileWrap.find('.mobile-clear-btn').on('click', function() {
        $mobileWrap.find('.mobile-term-btn').removeClass('checked');
      });
    }
    

    function updateFilters(type = 'desktop') {

      let selectedFilters = [];

      if (type == 'desktop') {
        // Gather the selected filters
        $('#filter-dropdown .filter-dropdown-term').each(function() {
          const $termBtn = $(this).find('.term-btn');

          if ($(this).find('.term-btn').hasClass('checked')) {
            selectedFilters.push($termBtn.data('term-id'));
          }
        });
      } else if (type == 'mobile') {
        // Gather the selected filters
        $mobileWrap.find('.mobile-term-btn.checked').each(function() {
          const termId = $(this).data('term-id');
          selectedFilters.push(termId);
        });
      }

      // Set the URL appropriately..
      const baseUrl = window.location.origin + window.location.pathname;

      if (selectedFilters.length > 0) {
        window.location.replace(baseUrl + '?tax=' + selectedFilters.join('+'));
      } else {
        window.location.replace(baseUrl);
      }

    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/chipFilters.js